import { CmsCustomPackage, extendComponentDefinitions } from '@grandvisionhq/bloomreach'

// Custom packages go here
import { ComparisonSlider } from '@grandvisionhq/pblx-comparison-slider'
import { ContactLensesTabs } from '@grandvisionhq/pbe-tabs-contact-lenses'

export const customComponents = {
  'comparison-slider-nightview': { type: ComparisonSlider, props: { type: 'nightview' } },
  'comparison-slider-sunglasses': { type: ComparisonSlider, props: { type: 'sunglasses' } },
  'comparison-slider-roadview': { type: ComparisonSlider, props: { type: 'roadview' } },
  'tabs-contactlenzen': { type: ContactLensesTabs, props: { openOnInit: 'true' } },
}

export const componentDefinitions = extendComponentDefinitions({
  'Custom Package': CmsCustomPackage,
})
